import { AppUI } from '@seedlang/state';

const WhitelabelOnly = ({ children }) => {
  if (AppUI.siteIsDefault) {
    return null;
  }

  return children;
};

export default WhitelabelOnly;